export const ReportMessages = {
  ENTER_NAME: '이름을 입력해주세요.',
  SELECT_DAILY_REPORT_TYPE: '리포트 타입을 선택해주세요.',
  ENTER_DATE: '날짜를 입력해주세요.',
  ENTER_TIME: '시간을 입력해주세요.',
  ENTER_CONTENT: '내용을 입력해주세요.',
  MEMO_LESS_OR_EQUALS_THAN_300: '메모는 300자 이하로 작성해주세요.',
} as const;
